import React from 'react';
import { MouseTracker } from './components/MouseTracker';

function App() {
  return <MouseTracker />;
}

export default App;
